module.exports = __webpack_public_path__ + "static/media/ViewStudentAppointmentData.5b7be2d6.xlsx";